namespace Areas.Account.View {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Account",
        "View",
        ["Profile","AccountStatusReport", "Workflows", "CIB", "PWC", "Milestones", "Schedule", "Team", "Module", "Analysis", "Finance", "Report"]);


    let summaryTabItems = Areas.createTabsWithSameAction("Account","View",
        ["ContractsSummary", "InspectionsSummary", "GLSummary", "GLDetailSummary", "RechargeSummary", "YearMonthChart", "YearMonthGLChart"]);

    let financeTabItems = Areas.createTabsWithSameAction("Account", "View",
        ["FinanceValidFund", "FinanceRechargeJob", "FinanceFunding"]); 

    let reportTabItems = Areas.createTabsWithSameAction("Account",
        "View",
        ["Report1", "Report2"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function summaryTabInitialized(params: any) {
        return Areas.tabWithIdInitialized(summaryTabItems)(params);
    }

    export function financeTabInitialized(params: any) {
        return Areas.tabWithIdInitialized(financeTabItems)(params);
    }

    export function reportTabInitialized(params: any) {
        return Areas.tabWithIdInitialized(reportTabItems)(params);
    }

}

